import { frontendURL } from '../../../helper/URLHelper';

const CobrancasView = () => import('./CobrancasView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/cobrancas'),
    name: 'cobrancas_dashboard',
    meta: {
      permissions: ['administrator'],
    },
    component: CobrancasView,
  },
];
